import { render, staticRenderFns } from "./CampoClient.vue?vue&type=template&id=40558319&scoped=true"
import script from "./CampoClient.vue?vue&type=script&lang=js"
export * from "./CampoClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40558319",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40558319')) {
      api.createRecord('40558319', component.options)
    } else {
      api.reload('40558319', component.options)
    }
    module.hot.accept("./CampoClient.vue?vue&type=template&id=40558319&scoped=true", function () {
      api.rerender('40558319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/CampoClient.vue"
export default component.exports